import { render, staticRenderFns } from "./ModuleText.vue?vue&type=template&id=a3408956&scoped=true&"
import script from "./ModuleText.vue?vue&type=script&lang=js&"
export * from "./ModuleText.vue?vue&type=script&lang=js&"
import style0 from "./ModuleText.vue?vue&type=style&index=0&id=a3408956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3408956",
  null
  
)

export default component.exports